import Subject from "../cse4sub/Subject";
import React from 'react'
import cse from '../assets/ECE303end21.pdf'
import csm from '../assets/ECE303mid21.pdf'

export default function Dsd() {
  return (
    <div>
       <Subject title="Digital System Design(ECE303)"mid="Q. Paper"
    book1=" " book2=" "
    book1Link="#" book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}